import useApplicationSettings from "../../../../Store/ApplicationSettings";
import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import styles from "./GiveawayList.module.css";
import { getShortGiveaway } from "../../../../Services/Requests";
import { Loader } from "../../../../Components/Loader/Loader";
import { GiveawayItem } from "../GiveawayItem/GiveawayItem";
import { useTabStore } from "../../../../Store/TabStore";

type TabType = "active" | "archive";

interface MainPrize {
  amount: number;
  type: string;
  item_type: string;
}

interface Giveaway {
  background: string;
  end_date: string;
  id: number;
  main_prizes: MainPrize[];
  start_date: string;
  status: string;
  coupons_purchased_dc: number;
  coupons_purchased_stars: number;
}

const GiveawayList = () => {
  const [activeGiveaways, setActiveGiveaways] = useState<Giveaway[]>([]);
  const [archieveGiveaways, setArchieveGiveaways] = useState<Giveaway[]>([]);
  const [activeTab, setActiveTab] = useState<TabType>("active");
  const tab = useTabStore((state) => state.tab);
  const setTab = useTabStore((state) => state.setTab);
  const navigate = useNavigate();
  const tg = window.Telegram.WebApp;
  const { setShowMenubar } = useApplicationSettings((state) => ({
    setShowMenubar: state.setShowMenubar,
  }));
  const handleBack = useCallback(() => {
    navigate("/earn");
  }, [navigate]);

  useEffect(() => {
    setShowMenubar(false);
    tg.BackButton.show();
    tg.BackButton.onClick(handleBack);
    return () => {
      tg.BackButton.offClick(handleBack);
    };
  }, [handleBack, tg.BackButton, setShowMenubar]);

  useEffect(() => {
    const fetchDetailedGiveaway = async () => {
      try {
        const response = await getShortGiveaway();
        if (response) {
          setActiveGiveaways(
            response.filter(
              (giveaway: Giveaway) =>
                giveaway.status === "active" ||
                giveaway.status === "winner_selection"
            )
          );
          setArchieveGiveaways(
            response.filter(
              (giveaway: Giveaway) => giveaway.status === "finish"
            )
          );
          if (tab === "active") {
            setActiveTab("active");
          } else {
            setActiveTab("archive");
          }
        }
      } catch (error) {
        console.error("Ошибка:", error);
      }
    };
    fetchDetailedGiveaway();
  }, []);

  const handleTabChange = (tab: TabType) => {
    setActiveTab(tab);
    setTab(tab);
  };

  const handleGiveawayClick = (id: number) => {
    navigate(`/giveaway/${id}`);
  };

  if (activeGiveaways.length === 0 && archieveGiveaways.length === 0) {
    return <Loader />;
  }

  return (
    <div className={styles.container}>
      <div className={styles.wrapper}>
        <div className={styles.tabContainer}>
          <div
            className={`${styles.tab} ${
              activeTab === "active" ? styles.active : ""
            }`}
            onClick={() => handleTabChange("active")}
          >
            Активные
          </div>
          <div
            className={`${styles.tab} ${
              activeTab === "archive" ? styles.active : ""
            }`}
            onClick={() => handleTabChange("archive")}
          >
            Архив
          </div>
          <div
            className={`${styles.slider} ${
              activeTab === "archive" ? styles.archive : ""
            }`}
          />
        </div>

        <div className={styles.giveawaysList}>
          {activeTab === "active"
            ? activeGiveaways.map((giveaway) => (
                <GiveawayItem
                  key={giveaway.id}
                  giveaway={giveaway}
                  onGiveawayClick={handleGiveawayClick}
                />
              ))
            : archieveGiveaways.map((giveaway) => (
                <GiveawayItem
                  key={giveaway.id}
                  giveaway={giveaway}
                  isArchive
                  onGiveawayClick={handleGiveawayClick}
                />
              ))}
        </div>
      </div>
    </div>
  );
};

export default GiveawayList;
